import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { TooltipModule } from 'primeng/tooltip';

import { CoreModule } from '../../Core/core.module';
import { LocalizationModule } from '../../Core/Localization/localization.module';
import { CommonBasicModule } from '../Basic/basic.module';
import { CommonFormsModule } from '../Forms/forms.module';
import { LayoutModule } from '../Layout/layout.module';
import { MiscModule } from '../Misc/misc.module';
import { BuyQuotaDialogComponent } from './components/BuyQuotaDialog/buy-quota-dialog.component';
import { EntityDetailsComponent } from './components/EntityDetails/entity-details.component';
import { EntityBusinessCardComponent } from './components/EntityBusinessCard/entity-business-card.component';
import { EntityBusinessCardExpandedComponent } from './components/EntityBusinessCardExpanded/entity-business-card-expanded.component';
import { EntityDetailsTabComponent } from './components/EntityDetailsTab/entity-details-tab.component';
import { UserNotesComponent } from './components/UserNotes/user-notes.component';
import { ContactService } from './services/contact-service';
import { DistributionService } from './services/distribution.service';
import { TargetingGeographyService } from './services/targeting-geography-service';
import { TargetingPreferencesService } from './services/targeting-preferences.service';
import { ReachFilterComponent } from './components/ReachFilter/reach-filter.component';
import { FilterModule } from '../../Common/Filter/filter.module';
import { TargetingBatchActionsDialogComponent } from './components/TargetingBatchActionsDialog/targeting-batch-actions-dialog.component';
import { TemplateCardComponent } from './components/TemplateCard/template-card.component';
import { CompositionReportComponent } from './components/statisticReport/CompositionReport/composition.report.component';
import { UndesirablesReportComponent } from './components/statisticReport/RecipientReport/UndesirablesReport/undesirables.report.component';
import { RecipientReportComponent } from './components/statisticReport/RecipientReport/recipient.report.component';
import { PerformanceReportComponent } from './components/statisticReport/PerformanceReport/performance.report.component';
import { PerformanceTrackingCardComponent } from './components/statisticReport/PerformanceTrackingCard/performance-tracking-card.component';
import { ProgressBarModule } from 'primeng/progressbar';
import { ChartsModule } from '../Charts/charts.module';
import {
    IndividualRecipientReportComponent
} from './components/statisticReport/RecipientReport/IndividualRecipientReport/individual.recipient.report.component';
import { TargetingSearchFormService } from './services/targeting-search-form.service';
import { SearchSummaryComponent } from './components/SearchSummary/search-summary.component';
import { DiscoverListPickerComponent } from './components/DiscoverListPicker/discover-list-picker.component';
import { TargetingSearchesApiService } from '@api/targeting/targeting-searches.api.service';
import { NotesTargetingComponent } from './components/Notes/notes.component';

@NgModule({
    imports: [
        LocalizationModule,
        CommonModule,
        CommonBasicModule,
        FormsModule,
        MiscModule,
        LayoutModule,
        CommonFormsModule,
        TooltipModule,
        CoreModule,
        FilterModule,
        ProgressBarModule,
        ChartsModule,
    ],
    declarations: [
        EntityDetailsTabComponent,
        EntityDetailsComponent,
        EntityBusinessCardComponent,
        EntityBusinessCardExpandedComponent,
        UserNotesComponent,
        BuyQuotaDialogComponent,
        ReachFilterComponent,
        TargetingBatchActionsDialogComponent,
        TemplateCardComponent,
        CompositionReportComponent,
        UndesirablesReportComponent,
        RecipientReportComponent,
        IndividualRecipientReportComponent,
        PerformanceReportComponent,
        PerformanceTrackingCardComponent,
        SearchSummaryComponent,
        DiscoverListPickerComponent,
        NotesTargetingComponent
    ],
    exports: [
        EntityDetailsTabComponent,
        EntityDetailsComponent,
        EntityBusinessCardComponent,
        EntityBusinessCardExpandedComponent,
        UserNotesComponent,
        BuyQuotaDialogComponent,
        ReachFilterComponent,
        TargetingBatchActionsDialogComponent,
        TemplateCardComponent,
        CompositionReportComponent,
        UndesirablesReportComponent,
        RecipientReportComponent,
        IndividualRecipientReportComponent,
        PerformanceReportComponent,
        PerformanceTrackingCardComponent,
        SearchSummaryComponent,
        DiscoverListPickerComponent,
        NotesTargetingComponent
    ],
    providers: [
        TargetingPreferencesService,
        TargetingSearchFormService,
        TargetingGeographyService,
        ContactService,
        DistributionService,
        TargetingSearchesApiService
    ],
})
export class TargetingSharedModule { }
